import { SVGProps } from "react";

const PlusIcon = (props: SVGProps<SVGSVGElement>) => {
  const { width = 24, height = 24, fill = "#fff" } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
    >
      <path
        fill={fill}
        fillRule="evenodd"
        d="M12 20.8a8.8 8.8 0 1 0 0-17.6 8.8 8.8 0 0 0 0 17.6Zm0 1.2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z"
        clipRule="evenodd"
      />
      <path
        fill={fill}
        fillRule="evenodd"
        d="M12.6 12.6h5.057v-1.2H12.6V6.343h-1.2V11.4H6.343v1.2H11.4v5.057h1.2V12.6Z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default PlusIcon;
